export class RequestFailedError extends Error {
  constructor(public readonly status: number) {
    super(`Request failed with status ${status}`);
    this.name = 'RequestFailedError';
  }
}
